import { sections } from "@/configs/discover";
import { Flex, Text } from "@mantine/core";
import { Link, useParams } from "react-router";
import "./DiscoverNavbar.css";

export function DiscoverNavbar() {
  const { section } = useParams();
  const isActive = (s: string) => section === s;

  return (
    <Flex
      direction="column"
      w={200}
      miw={200}
      pos="sticky"
      top={80}
      gap="lg"
      mt={10}
      style={{ zIndex: 5, height: "fit-content" }}
    >
      {sections.map((s) => (
        <DiscoverNavbarItem
          key={s.id}
          href={`/discover/${s.id}`}
          title={s.title}
          icon={s.icon}
          isActive={isActive(s.id)}
        />
      ))}
    </Flex>
  );
}

function DiscoverNavbarItem({
  title,
  icon,
  href,
  isActive,
}: {
  title: string;
  icon: React.ComponentType<any>;
  href: string;
  isActive: boolean;
}) {
  const IconComponent = icon;

  return (
    <Link to={href} className="discover-navbar-item">
      <Flex px="xs" py={4} direction="row" gap="xs" align="center">
        <IconComponent
          color={
            isActive
              ? "var(--mantine-color-eu_flag-filled)"
              : "var(--mantine-color-dark-8)"
          }
          size={18}
          stroke={isActive ? 2 : 1.5}
        />
        <Text
          c={isActive ? "eu_flag.9" : "dark.8"}
          className="discover-navbar-item-title"
          fz={16}
          fw={isActive ? 600 : 400}
        >
          {title}
        </Text>
      </Flex>
    </Link>
  );
}
